import React from 'react';
import {Route, Routes} from "react-router-dom";
import ProfileDetail from "./profileDetail";


const ProfileRoutes = () => {
    return (
        <Routes>
            <Route path="/*" element={<ProfileDetail />} />
        </Routes>
    );
}


export default ProfileRoutes;
